module.exports = __webpack_public_path__ + "static/img/best-score-slider04.48df335.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/best-score-slider04.jpg
// module id = 224
// module chunks = 0